import React from 'react';
const TutorialIcon = () => {
    return <svg width="48" height="49" viewBox="0 0 48 49" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect y="0.5" width="48" height="48" rx="24" fill="#F2F1FF" />
        <path fillRule="evenodd" clipRule="evenodd" d="M29.375 23.4852C30.5417 24.1587 30.5417 25.8427 29.375 26.5163L21.875 30.8464C20.7083 31.52 19.25 30.678 19.25 29.3308L19.25 20.6706C19.25 19.3234 20.7083 18.4815 21.875 19.155L29.375 23.4852ZM28.625 25.2172C28.7917 25.121 28.7917 24.8804 28.625 24.7842L21.125 20.4541C20.9583 20.3578 20.75 20.4781 20.75 20.6706L20.75 29.3308C20.75 29.5233 20.9583 29.6436 21.125 29.5473L28.625 25.2172Z" fill="#202223" />
    </svg>
};

export default TutorialIcon;

